import { Container } from "react-bootstrap";

import LanguageChangeDropdown from "../common/LanguageChangeDropdown";

type Props = {
  theme?: string;
  className?: string;
};

function SiteFooterComponent({ theme, className }: Props) {
  return (
    <footer
      className={`p-2 ${
        theme == "light" ? "bg-eightColor" : "bg-firstColor"
      } ${className}`}
    >
      <Container fluid={"xl"}>
        <div className="gap-3  d-flex flex-column justify-content-center align-content-center align-items-center">
          <div className="d-flex  justify-content-between   w-100">
            <div className="d-flex gap-3 align-items-center">
              <span
                className={`${
                  theme == "light" ? "color-fifthColor" : "color-sevenColor"
                } tw-text-[50%]`}
              >
                © LouiseBot {new Date().getFullYear()} -{" "}
                {import.meta.env.VITE_IMAGE_VERSION}
              </span>
            </div>
            <div className="d-flex align-items-center">
              <LanguageChangeDropdown theme={theme} />
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
}

export default SiteFooterComponent;
